import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Divider from '../components/Divider'
import CTAButton from '../components/CTAButton'
import Hero from '../components/Hero'
import CenterRow from '../components/CenterRow'
import Heading from '../components/Heading'
import AppsAndService from '../components/AppsAndService'
import LeadForm from '../components/LeadForm'

class LearnPage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

		const meta = {
  		description: "ACS provides many industrial and power related markets with acoustic cleaners (sonic horns) to solve all their material handling problems. With experience dating back to 1989, ACS has tested methods and proven innovative products that get the job done right. Our products are also direct replacements for all major sonic horn brands making us a clear choice for your repair and upgrade situations.",
  		keywords: "Acoustic Cleaning Systems",
  		headline: "Acoustic Cleaning Systems: Acoustic cleaners done right.",
  		title: "Acoustic Cleaning Systems: Acoustic cleaners done right."
  	}

    return (
      <div className="learn-page">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
				<Hero headline='Put Our Experience to Work for You.'
					className="applications"
					images={[
						'/images/hero/1.jpg',
						'/images/hero/2.jpg',
						'/images/hero/0.jpg',
					]}
				>
					<LeadForm />
				</Hero>
				<div className="container page installations-page">

					<br /><br />
					<CenterRow headline="Experience that dates back to 1983.">
						Over the years at ACS we have learned a lot about cleaning with sound. Here are some
						highlights of the knowledge we have gained as a company and some entry level insight to what
						acoustic cleaning entails.
					</CenterRow>
					<Divider />
					<div className="row center-xs">
						<div className="col-md-6">
							<img style={{margin:'auto'}} src="/images/cleaning-with-sound.jpg" />
							<br /><br />
							<h2>Cleaning With Sound</h2>
							<p className="left">
								Audiosonic acoustic cleaning is a non-intrusive technology designed to remove particulate
								buildup of dry materials in many industrial applications. Acoustic cleaners manufactured by ACS
								provide a highly efficient, cost-effective solution to eliminate buildup, blockage, and thermal
								transfer problems in a variety of industries.
						 	</p>
							<br /><br />
							<h2>The Fundamentals</h2>
							<p className="left">
								ACS acoustic cleaners are simple in modular construction. They feature two basic components,
								bells for maximum output efficiency and a sound generator. Acoustic cleaners are
								pneumatically operated to produce low frequency, high energy sound waves. Each model horn
								produces different frequencies based on the size and shape of the bell. We use these varying
								frequencies and outputs to select the correct cleaner for each application.
							</p>
						</div>
					</div>
					<Divider />
					<div className="row center-xs">
						<div className="col-md-6">
							<img style={{ margin:'auto', height: 200, width: 'auto' }} src="/images/how-it-works.jpg" />
							<br/>
							<br/>
							<h2>How It Works</h2>
							<p className="left">
								The function of an acoustic cleaner is simple, compressed air is introduced through a specific
								orifice and causes the titanium diaphragm to flex. The flexing causes a pressure pulse to be
								produced that is then amplified by the bell. The length and flare constant of the bell is what
								determines the fundamental frequency of each specific cleaner.
							</p>
							<br/>
							<p className="left">
								The sound pressure produced by the bell causes particulate deposits to resonate and dislodge.
								Once dislodged, the material is removed by gravity and/or gas flow, depending on the
								application. Acoustic cleaning is a non-intrusive technology designed to remove particulate ash,
								dust, powder or any other dry material casing buildup blockage, or thermal transfer problems.
							</p>
							<br/>
							<p className="left">
								Acoustic cleaners are effective in a wide range of applications; therefore, they are offered in
								various frequencies and sizes. The lower the fundamental frequency the greater the cleaning
								area as well as the physical size of the unit.
							</p>
						</div>
					</div>
					<Divider />
					<AppsAndService />
				</div>
    	</div>
    )
  }
}

LearnPage.propTypes = {}
LearnPage.defaultProps = {}
LearnPage.data = {
  menuLabel: 'Learn',
	excludeFromMenu: true,
  menuShortDescription: 'Learn for Acoustic Cleaning Services, Inc.'
}
export default LearnPage



// WEBPACK FOOTER //
// ./learn.js